export default function isAuthorized(requiredRoles) {
  try {
    const roles = localStorage.getItem("roles");
    const isAuthorized = requiredRoles.includes(roles)
    return isAuthorized;
  } catch (error) {
    console.log("erro isAuthorized: ", false);
    return false;
  }
}